import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";

import { GridCloseIcon } from "@mui/x-data-grid";
import { makeStyles } from "@material-ui/core";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialog-paper": {
    borderRadius: "12.1px",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
    marginBottom: "16px",
  },
}));

const useStyles = makeStyles((theme) => ({
  containerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    [theme.breakpoints.up("sm")]: {
      // margin: "0 20px",
      minWidth: "300px",
    },
    [theme.breakpoints.up("md")]: {
      // margin: "20px 0",
      minWidth: "520px",
    },
  },
  button: {
    backgroundColor: "#B965D3",
    borderRadius: "4px",
    boxSizing: "borderBox",
    outline: "0",
    border: "0",
  },
  title: {
    fontFamily: "Fredoka One",
    margin: "0 auto",
    fontSize: "20px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.23px",
    textAlign: "center",
    marginBottom: "20px",
    color: "#000",
    // maxWidth: "30ch",
    width: "80%",
    [theme.breakpoints.up("sm")]: {
      fontSize: "24px",
      // margin: "10px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "32px",
      // margin: "10px",
    },
  },
  text: {
    fontFamily: "Lato",
    margin: "0 auto",
    fontSize: "14px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.23px",
    textAlign: "center",
    color: "#000",
    width: "80%",
    [theme.breakpoints.up("sm")]: {
      fontSize: "16px",
      // margin: "10px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "22px",
      margin: "10px auto",
    },
  },
  tableContent: {
    borderCollapse: "collapse",
    tableLayout: "fixed",
    width: "auto",
    margin: "0 auto",
    border: "1px solid #979797",
  },
  tRow: {
    border: "1px solid #979797",
  },
  thData: {
    border: "1px solid #979797",
    color: "#505759",
    fontWeight: "bold",
    textAlign: "center",
    padding: "10px 20px",
    fontSize: "16px",
    letterSpacing: "0.36px",
    [theme.breakpoints.up("md")]: {
      fontSize: "18px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "22px",
    },
  },
  tData: {
    border: "1px solid #979797",
    fontFamily: "Lato",
    color: "#505759",
    textAlign: "center",
    padding: "5px",
    fontSize: "14px",
    letterSpacing: "0.36px",
    [theme.breakpoints.up("md")]: {
      fontSize: "20px",
    },
  },
  tdataLeft: {
    border: "1px solid #979797",
    textAlign: "center",
    padding: "5px",
    fontSize: "16px",
    letterSpacing: "0.36px",
    [theme.breakpoints.up("md")]: {
      fontSize: "18px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "22px",
    },
  },
}));

const PurpleButton = styled(Button)(({ theme }) => ({
  color: "#FFFFFF",
  backgroundColor: "#9051b1",
  borderRadius: "30px",
  margin: "0 auto",
  textTransform: "unset",
  width: "auto",
  minWidth: "115px",
  maxWidth: "130px",
  "&:hover": {
    backgroundColor: "#B965D3 ",
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 4 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <GridCloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const ModalErrorDetails = ({ open, handleClose }) => {
  const classes = useStyles();
  return (
    <>
      <BootstrapDialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} maxWidth="lg">
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}></BootstrapDialogTitle>
        <DialogContent>
          <div className={classes.containerContent}>
            <h3 className={classes.title}>Carga fallida</h3>
            <h4 className={classes.text}>
              La foto que intentas cargar no cumple con los requisitos o tiene contenido prohibido como:
            </h4>
            <br />
            <table cellPadding="0" cellSpacing="0" className={classes.tableContent}>
              <thead>
                <tr>
                  <td className={classes.thData}>Categoría de nivel superior</td>
                  <td className={classes.thData}>Categoría de segundo nivel</td>
                </tr>
              </thead>
              <tbody>
                {/* <tr className={classes.tRow}>
                    <td className={classes.tData}>Categoría de nivel superior</td>
                    <td className={classes.tData}>Categoría de segundo nivel</td>
                  </tr> */}
                <tr className={classes.tRow}>
                  <td rowSpan="6" className={classes.tdataLeft}>
                    Desnudo explícito
                  </td>
                  <td className={classes.tData}>Desnudo</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Desnudo masculina gráfica</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Desnudo femenino gráfico</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Actividad sexual</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Desnudo explícito ilustrado</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Juguetes para adultos</td>
                </tr>
                <tr className={classes.tRow}>
                  <td rowSpan="6" className={classes.tdataLeft}>
                    Insinuante
                  </td>
                  <td className={classes.tData}>Roba de baño o ropa interior femenina</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Roba de baño o ropa interior masculina</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Desnudo parcial</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Hombre con barechested</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Ropa provocativa</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Situaciones sexuales</td>
                </tr>
                <tr className={classes.tRow}>
                  <td rowSpan="5" className={classes.tdataLeft}>
                    Violencia
                  </td>
                  <td className={classes.tData}>Violencia gráfica o sangre</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Violencia física</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Violencia con armas</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Armas</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Autolesiones</td>
                </tr>
                <tr className={classes.tRow}>
                  <td rowSpan="5" className={classes.tdataLeft}>
                    Visualmente perturbador
                  </td>
                  <td className={classes.tData}>Cuerpos desnutridos</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Cadáveres</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Personas colgadas</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Air Crash</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Explosiones y explosiones</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Gestos groseros</td>
                  <td className={classes.tData}>Dedo medio</td>
                </tr>
                <tr className={classes.tRow}>
                  <td rowSpan="4" className={classes.tdataLeft}>
                    Drogas
                  </td>
                  <td className={classes.tData}>Productos de medicamentos</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Consumo de drogas</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Pastillas</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Parafernalia farmacológica</td>
                </tr>
                <tr className={classes.tRow}>
                  <td rowSpan="2" className={classes.tdataLeft}>
                    Tabaco
                  </td>
                  <td className={classes.tData}>Productos de tabaco</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Fumar</td>
                </tr>
                <tr className={classes.tRow}>
                  <td rowSpan="2" className={classes.tdataLeft}>
                    Alcohol
                  </td>
                  <td className={classes.tData}>Beber</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Bebidas alcohólicas</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Juegos de azar</td>
                  <td className={classes.tData}>Juegos de azar</td>
                </tr>
                <tr className={classes.tRow}>
                  <td rowSpan="3" className={classes.tdataLeft}>
                    Símbolos de
                  </td>
                  <td className={classes.tData}>Partido nazi</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Supremacía Blanca</td>
                </tr>
                <tr className={classes.tRow}>
                  <td className={classes.tData}>Extremista</td>
                </tr>
              </tbody>
            </table>

            <br />
          </div>
        </DialogContent>
        <DialogActions>
          <PurpleButton onClick={handleClose} className={classes.button} variant="contained">
            Continuar
          </PurpleButton>
        </DialogActions>
      </BootstrapDialog>
    </>
  );
};
export default ModalErrorDetails;
